import type { IconData } from '../../types';

export const data: IconData = {
  o: '<mask id="a" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path d="M0 0h16v16H0z"/></mask><g mask="url(#a)"><path fill="#181C22" d="M4 14H2v-2a2 2 0 0 1 1-2V9l1-1 1-1h2V5H6V4l1-2h2l1 2a2 2 0 0 1-1 1v2h2l1 1 1 1v1l1 1v3h-3l-1-2a2 2 0 0 1 2-2V9H9v1l1 1v1l-1 2H7l-1-2a2 2 0 0 1 1-2V9H4v1l1 1 1 1-1 2H4Zm0-1v-1H3v1h1Zm4 0h1v-1H7v1h1Zm4 0h1v-1h-1v1ZM8 4h1V3H7v1h1Z"/></g>',
  f: '<mask id="a" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path d="M0 0h20v20H0z"/></mask><g mask="url(#a)"><path d="M5 17H3v-2a2 2 0 0 1 1-2v-2l1-1 1-1h3V7L8 6V3h4v2a2 2 0 0 1-1 2v2h3l1 1 1 1v2l1 1v3h-4v-2a2 2 0 0 1 1-2v-2h-3v2l1 1v3H8v-2a2 2 0 0 1 1-2v-2H6v2l1 1v3H5Z"/></g>',
  vb: '0 0 20 20',
  vbo: '0 0 16 16',
  raf: { fill: 'none' },
};

export default data;
